import React from "react";
import { DialogComponent } from "../../DialogComponent/DialogComponent";
import { ButtonBase, DialogContentText } from "@material-ui/core";
import { WarningOutlined } from "@material-ui/icons";
import { useLayoutDetection } from "../../../Hooks";
import { CustomDialog } from "../../V2";

const CanCommunicateAlertDialog = ({
  open,
  onClose,
  onConfirm,
  canCommunicate,
}) => {
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = hasNewLayout && isReskinningLayout;
  if (!open) {
    return null;
  }

  if (isNewLayout) {
    return (
      <CustomDialog
        open={open}
        onClose={onClose}
        title={"Contact Blocked on DNCR"}
        maxWidth={"sm"}
        content={
          <div className="flex d-flex-column fa-center fj-center gap-4">
            <WarningOutlined fontSize="large" className="text-warning" />
            <DialogContentText className="text-center texts gray-primary-bold">
              This contact is currently listed on the Do Not Call Register
              (DNCR). You are not permitted to call this number due to
              compliance regulations.
              <br />
              If you need to discuss this case, please use approved
              communication channels.
            </DialogContentText>
          </div>
        }
        confirmText={"Proceed"}
        onConfirm={onConfirm}
        isDisabled={!canCommunicate}
        cancelText={"Cancel"}
      />
    );
  }

  return (
    <DialogComponent
      isOpen
      onCloseClicked={onClose}
      titleText={"Contact Blocked on DNCR"}
      maxWidth={"sm"}
      dialogContent={
        <div className="flex d-flex-column fa-center fj-center gap-4">
          <WarningOutlined fontSize="large" className="text-warning" />
          <DialogContentText className="text-center texts gray-primary-bold">
            This contact is currently listed on the Do Not Call Register (DNCR).
            You are not permitted to call this number due to compliance
            regulations.
            <br />
            If you need to discuss this case, please use approved communication
            channels.
          </DialogContentText>
        </div>
      }
      dialogActions={
        <div className="flex gap-4 fj-end w-100 px-3 py-2">
          <ButtonBase
            className="btns theme-solid"
            color="#FFFFFF"
            onClick={onConfirm}
            disabled={!canCommunicate}
          >
            <span className="mdi mdi-alert px-1" />
            Proceed
          </ButtonBase>
          <ButtonBase className=" btns theme-outline" onClick={onClose}>
            Cancel
          </ButtonBase>
        </div>
      }
    />
  );
};
export default CanCommunicateAlertDialog;
